import { render, staticRenderFns } from "./UserFiling.vue?vue&type=template&id=5cd8a8df&scoped=true&"
import script from "./UserFiling.vue?vue&type=script&lang=js&"
export * from "./UserFiling.vue?vue&type=script&lang=js&"
import style0 from "./UserFiling.vue?vue&type=style&index=0&id=5cd8a8df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd8a8df",
  null
  
)

export default component.exports